<template>
    <div class="dashboard-container">
        <div v-if="showWelcomeModal" class="welcome-modal-overlay">
            <div class="welcome-modal-card">
                <h2 class="welcome-modal-title">Welcome Aboard! You're Now Protected 🚀</h2>
                <div class="welcome-modal-plan">
                    <b>You've activated the {{ planName }} Plan – Monitoring up to {{ monitorCount }} services every {{ monitorInterval }} seconds.</b>
                </div>
                <div class="welcome-modal-desc">
                    "Real-time alerts are now just moments away. Add your first website or API to begin monitoring instantly. It takes less than 30 seconds!"
                </div>
                <div class="welcome-modal-email">
                    Your validate mail : {{ userEmail }}
                </div>
                <div class="welcome-modal-input-row">
                    <div class="welcome-modal-input-container">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="welcome-modal-user-icon">
                            <circle cx="12" cy="8" r="4" stroke="#1C274C" stroke-width="1.5" fill="none" opacity="0.4"/>
                            <path d="M4 20C4 17.7909 5.79086 16 8 16H16C18.2091 16 20 17.7909 20 20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V20Z" stroke="#1C274C" stroke-width="1.5" fill="none" opacity="0.4"/>
                        </svg>
                        <input 
                            type="text" 
                            v-model="username" 
                            placeholder="Enter your name"
                            class="welcome-modal-input"
                            @keyup.enter="completeProfile"
                        />
                    </div>
                    <button 
                        class="welcome-modal-complete-btn" 
                        :disabled="!username.trim()"
                        @click="completeProfile"
                    >
                        Complete Profile
                    </button>
                </div>
            </div>
        </div>
        <div class="row m-0">
            <!-- Mobile Breadcrumbs - Keep existing component -->
            <Breadcrumbs main="" title="Dashboard" class="showBreadcrumbs" />
            
            <!-- Desktop Breadcrumbs - Custom implementation -->
            <div class="desktop-breadcrumbs-wrapper hideBreadcrumbs">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb desktop-breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ path: '/app/dashboard' }">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
                    </ol>
                </nav>
                <add-monitor-button />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <report-vue></report-vue>
            </div>
        </div> 
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 report p-3">
                    <div slot="with-padding">
                        <div class="col-md-12 overall-uptime-container">
                    <!-- Header Section -->
                    <div class="overall-uptime-header">
                        <h2 class="overall-uptime-title">Overall Uptime</h2>
                        <div class="overall-uptime-dropdown-wrapper col-md-3">
                            <img src="@/assets/icons/monitor-selector.svg" alt="Monitor" class="monitor-icon" />
                            <multiselect
                                class="overall-uptime-dropdown"
                                :close-on-select="true"
                                v-model="selected_monitor"
                                tag-placeholder="Select Monitor" 
                                placeholder="Search by Monitor" 
                                label="text" track-by="value" 
                                :show-labels="false"
                                :options="monitor_options" 
                                :multiple="false"
                                @input="FilterUptime"
                                :title="selectedMonitorTitle"
                            >
                                <template #option="{ option }">
                                    <div class="d-flex justify-content-between" :title="option.text">
                                        <span class="cust_txt">{{ option.text }}</span>
                                        <span v-if="option.badge" class="badge badge-gray ml-2" style="font-size: 12px;">{{ option.badge }}</span>
                                    </div>
                                </template>
                                <template #singleLabel="{ option }">
                                    <span class="cust_txt" :title="option.text">{{ option.text }}</span>
                                </template>
                            </multiselect>
                            <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 10L12 15L17 10" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    
                    <!-- Uptime Cards -->
                    <div class="uptime-cards-wrapper">
                        <!-- Yesterday card commented out for now -->
                        <!-- <div class="uptime-card">
                            <div class="uptime-value">{{ overalluptime.d1 ? overalluptime.d1.uptime.toFixed(2) : '0.00' }}%</div>
                            <div class="uptime-label">Yesterday</div>
                        </div> -->
                        <div class="uptime-card">
                            <div class="uptime-value">{{ overalluptime.d7.uptime.toFixed(2) }}%</div>
                            <div class="uptime-label">Last 7 Days</div>
                        </div>
                        <div class="uptime-card">
                            <div class="uptime-value">{{ overalluptime.d30.uptime.toFixed(2) }}%</div>
                            <div class="uptime-label">Last 30 Days</div>
                        </div>
                        <div class="uptime-card">
                            <div class="uptime-value">{{ overalluptime.d90.uptime.toFixed(2) }}%</div>
                            <div class="uptime-label">Last 90 Days</div>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row mt-3">
                <div class="col-md-7 col-12">
                    <incedent-vue :monitor_data="monitor_opt"></incedent-vue>
                </div>
                <div class="col-md-5 col-12">
                    <event-vue :monitor_data="monitor_opt"></event-vue>
                </div>
            </div>
        </div>
        
        
    </div>
</template>


<script>
import IncedentVue from "./Incedent.vue";
import EventVue from "./Events.vue";
import ReportVue from "./Report.vue";
import MonitorsController from "../../services/monitorController";
import DashboardController from "../../services/dashboardController";
import AddMonitorButton from "../components/addMonitorButton.vue";
import UserService from '../../services/userController';
import Multiselect from 'vue-multiselect';
export default{
    name:'dashboard',
    components: { IncedentVue, EventVue, ReportVue, AddMonitorButton, Multiselect },
    data(){
        return {
            monitor_opt:{},
            monitor_options : [{ value: null, text: "All Monitor Uptime"}] ,
            overalluptime:{d1: { uptime: 0 }, d7: { uptime: 0 },d30: { uptime: 0 },d90: { uptime: 0 }},
            monitor:null,
            selected_monitor: null,
            showWelcomeModal: false,
            planName: '',
            monitorCount: 0,
            monitorInterval: 0,
            username: '',
            userEmail: '',
        }
    },
    mounted(){
        this.getMonitors();
        this.getUptime();
        this.selected_monitor = this.monitor_options[0];
        // Show welcome modal if user just came from Stripe
        this.getUserInfo();
        const planInfo = JSON.parse(localStorage.getItem('planInfo') || '{}');
        if (planInfo.showWelcomeModal && !this.username ) {
            this.showWelcomeModal = true;
            this.getPlanInfo();
        }
    },
    computed: {
        selectedMonitorTitle() {
            if (!this.selected_monitor) return 'All Monitor Uptime';
            return this.selected_monitor.text || 'All Monitor Uptime';
        }
    },
    methods:{
    FilterUptime(){
        if(this.selected_monitor && this.selected_monitor.value !== undefined){
            this.monitor = this.selected_monitor.value
        }else{
            this.monitor = null
        }
        this.getUptime()
    },
    async getMonitors() {
      let response = await MonitorsController.getMonitors();
      if (response.result) {
        response.data.map((t) => {
          let typeBadge = '';
          switch (t.type) {
              case 1:
                  typeBadge = 'HTTP(s)';
                  break;
              case 2:
                  typeBadge = 'Keyword';
                  break;
              case 3:
                  typeBadge = 'Ping';
                  break;
              case 4:
                  typeBadge = 'Port';
                  break;
              case 5:
                  typeBadge = 'Heartbeat';
                  break;
              case 6:
                  typeBadge = 'Page Speed';
                  break;
              case 7:
                  typeBadge = 'Page Screenshot';
                  break;
              default:
                  typeBadge = '';
          }
          this.monitor_options.push({ 
            value: t._id, 
            text: t.name, 
            type: t.type,
            isDown: t.isDown,
            badge: typeBadge 
          });
        });
      }
    },
    async getUptime(){
        var response 
        if(this.monitor){
            let payload = '?mid='+this.monitor
            response = await DashboardController.getUptimeByMid(payload)
        }
        else{
          response = await DashboardController.getUptime()
        }
        if(response.result){
            this.overalluptime = response.data
        }
    },
    async getPlanInfo() {
      try {
        const response = await UserService.getPlanInfo();
        if (response.result && response.message) {
          this.planName = response.message.plan_name;
          this.monitorCount = response.message.monitorcount;
          this.monitorInterval = response.message.minIntervalLimit * 60; // Convert minutes to seconds
        } 
      } catch (e) {
        console.error('Error fetching plan info:', e);
      }
    },
    getUserInfo() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userinfo') || '{}');
        if (userInfo && userInfo.email) {
          this.userEmail = userInfo.email;
          this.username = userInfo.username || '';
        }
      } catch (e) {
        console.error('Error getting user info from localStorage:', e);
      }
    },
    async completeProfile() {
      if (!this.username.trim()) return;
      try {
        const response = await UserService.profile({ username: this.username });
        if (response.result) {
          // Update localStorage with new username
          const userInfo = JSON.parse(localStorage.getItem('userinfo') || '{}');
          userInfo.username = this.username;
          localStorage.setItem('userinfo', JSON.stringify(userInfo));
          
          this.$toasted.show('Profile updated successfully!', {
            theme: "outline",
            position: "bottom-center",
            type: "success",
            duration: 2000
          });
          // Remove planInfo from localStorage after successful profile completion
          localStorage.removeItem('planInfo');
          this.showWelcomeModal = false;
        } else {
          this.$toasted.show(response.message || 'Failed to update profile', {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 2000
          });
        }
      } catch (e) {
        this.$toasted.show('Failed to update profile', {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000
        });
      }
    },
    closeWelcomeModal() {
        // Don't allow closing the modal when it was opened from Stripe
        return;
    },
    addMonitor() {
        this.showWelcomeModal = false;
        // Find and click the add monitor button/component
        const btn = document.querySelector('.add-monitor-btn-green, .add-monitor-btn');
        if (btn) btn.click();
    }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.dashboard-container {
    padding-top: 2rem;
    background-color: #F2F7FF;
    min-height: 100vh;
}

/* Overall Uptime Container */
.overall-uptime-container {
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 20px;
    padding: 30px;
}

/* Header Section */
.overall-uptime-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 40px;
}

.overall-uptime-title {
    font-family: 'Poppins', sans-serif;
    font-size: 30px;
    font-weight: 600;
    line-height: 0.915em;
    color: #3A3A3A;
    margin: 0;
}

/* Dropdown Wrapper */
.overall-uptime-dropdown-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #E8EEFD;
    border-radius: 10px;
    padding: 5px 15px;
    position: relative;
    min-width: 350px;
}

.monitor-icon {
    flex-shrink: 0;
    width: 30px;
    height: 25px;
}

/* Multiselect customization for overall uptime dropdown - matching incidents dropdown */
.overall-uptime-dropdown >>> .multiselect {
    min-height: unset;
    background: transparent;
    border: none;
    flex: 1;
    width: 100%;
    position: relative;
}

.overall-uptime-dropdown >>> .multiselect__tags {
    background: transparent !important;
    border: none !important;
    min-height: unset;
    padding: 0;
    max-width: 100% !important;
    overflow: hidden !important;
}

.overall-uptime-dropdown >>> .multiselect__input,
.overall-uptime-dropdown >>> .multiselect__single,
.overall-uptime-dropdown >>> .multiselect__placeholder {
    background: transparent !important;
    color: #000 !important;
    font-family: 'Poppins', sans-serif;
    font-size: 18px !important;
    font-weight: 500;
    padding: 0 !important;
    margin-top: 10px;
}

.overall-uptime-dropdown >>> .multiselect__select {
    display: none !important;
}

.overall-uptime-dropdown >>> .multiselect__tags:focus-within {
    box-shadow: none !important;
    border: none !important;
}

.overall-uptime-dropdown >>> .multiselect__option--highlight {
    font-size: 16px !important;
    font-family: 'Poppins', sans-serif;
}

.overall-uptime-dropdown >>> .multiselect__option {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
}

/* Ensure dropdown content takes full width of wrapper */
.overall-uptime-dropdown >>> .multiselect__content-wrapper {
    width: 100% !important;
    min-width: 350px !important;
    left: 2 !important;
    right: 0 !important;
}

.overall-uptime-dropdown >>> .multiselect__content {
    width: 100% !important;
    min-width: 100% !important;
}

/* Text wrapping for dropdown options */
.overall-uptime-dropdown >>> .multiselect__option .cust_txt {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 80px);
}

/* Text wrapping for selected values */
.overall-uptime-dropdown >>> .multiselect__single .cust_txt {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 40px);
}

/* Ensure the single value container doesn't overflow */
.overall-uptime-dropdown >>> .multiselect__single {
    overflow: hidden !important;
    display: block !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: calc(100% - 30px) !important;
    padding-right: 20px !important;
}

/* Ensure the flex container in selected template works properly */
.overall-uptime-dropdown >>> .multiselect__single .d-flex {
    width: 100%;
    min-width: 0;
}

/* Ensure badges don't get cut off */
.overall-uptime-dropdown >>> .multiselect__single .badge {
    flex-shrink: 0;
    margin-left: 8px;
}

.overall-uptime-dropdown:focus {
    box-shadow: none;
}

.dropdown-arrow {
    position: absolute;
    right: 12px;
    pointer-events: none;
}

/* Uptime Cards Wrapper */
.uptime-cards-wrapper {
    display: flex;
    gap: 30px;
    justify-content: space-evenly;
    margin: 20px;
}

/* Individual Uptime Card */
.uptime-card {
    flex: 0 1 350px;
    background: #FFFFFF;
    border: 1px solid #D2E3FB;
    border-radius: 15px;
    padding: 35px 20px;
    text-align: center;
}

.uptime-value {
    font-family: 'Poppins', sans-serif;
    font-size: 40px;
    font-weight: 600;
    line-height: 0.915em;
    color: #3A3A3A;
    margin-bottom: 15px;
}

.uptime-label {
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 0.915em;
    color: #161616;
}

/* Responsive Styles */
@media (max-width: 1200px) {
    .uptime-cards-wrapper {
        flex-wrap: wrap;
        gap: 15px;
    }
    
    .uptime-card {
        flex: 0 0 calc(50% - 8px);
    }
}

@media (max-width: 768px) {
    .overall-uptime-container {
        padding: 20px;
    }
    
    .overall-uptime-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        margin-bottom: 30px;
    }
    
    .overall-uptime-title {
        font-size: 24px;
    }
    
    .overall-uptime-dropdown-wrapper {
        width: 100%;
        justify-content: space-between;
    }
    
    .overall-uptime-dropdown >>> .multiselect__single,
    .overall-uptime-dropdown >>> .multiselect__placeholder {
        font-size: 16px !important;
    }
    
    .overall-uptime-dropdown >>> .multiselect__tags {
        max-width: 100% !important;
    }
    
    .uptime-cards-wrapper {
        flex-direction: column;
        gap: 12px;
    }
    
    .uptime-card {
        flex: 1 1 100%;
        padding: 25px 15px;
    }
    
    .uptime-value {
        font-size: 32px;
        margin-bottom: 10px;
    }
    
    .uptime-label {
        font-size: 18px;
    }
}

.welcome-modal-overlay {
    position: fixed;
    z-index: 3000;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(30, 34, 54, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
}
.welcome-modal-card {
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 4px 32px rgba(0,0,0,0.10);
    padding: 30px;
    max-width: 666px;
    width: 100%;
    text-align: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}
.welcome-modal-close {
    position: absolute;
    top: 24px;
    right: 32px;
    background: none;
    border: none;
    font-size: 2rem;
    color: #bfc7d1;
    cursor: pointer;
    z-index: 10;
    transition: color 0.2s;
    line-height: 1;
}
.welcome-modal-close:hover {
    color: #0b6cfa;
}
.welcome-modal-title {
    font-size: 22px;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    color: #3A3A3A;
    margin: 0;
    line-height: 91.5%;
}
.welcome-modal-plan {
    font-size: 14px;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    line-height: 91.5%;
    color: #3A3A3A;
    margin: 0;
}
.welcome-modal-desc {
    font-size: 12px;
    font-family: Poppins, sans-serif;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 1.5;
    margin: 0;
}
.welcome-modal-email {
    font-size: 12px;
    font-family: Poppins, sans-serif;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 1.5;
    margin: 0;
}
.welcome-modal-input-row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 1px;
}
.welcome-modal-input-container {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: #fff;
    border: 1px solid #D2E3FB;
    border-radius: 12px;
    box-shadow: 0px 0px 20px 0px rgba(11, 108, 250, 0.1);
}
.welcome-modal-user-icon {
    flex-shrink: 0;
}
.welcome-modal-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 18px;
    font-family: Poppins, sans-serif;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 91.5%;
}
.welcome-modal-input::placeholder {
    color: #3A3A3A;
    opacity: 0.4;
}
.welcome-modal-complete-btn {
    padding: 12px 12px;
    background: #0B6CFA;
    color: #fff;
    border: none;
    border-radius: 12px;
    font-size: 18px;
    font-family: Poppins, sans-serif;
    font-weight: 500;
    line-height: 1.5;
    cursor: pointer;
    transition: background 0.2s, opacity 0.2s;
    box-shadow: 0px 0px 20px 0px rgba(11, 108, 250, 0.1);
}
.welcome-modal-complete-btn:hover:not(:disabled) {
    background: #0956c7;
}
.welcome-modal-complete-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #7D8699;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
    .welcome-modal-card {
        padding: 20px;
        margin: 10px;
        max-width: calc(100vw - 20px);
    }
    .welcome-modal-input-row {
        flex-direction: column;
        gap: 12px;
    }
    .welcome-modal-input-container {
        width: 100%;
        padding: 15px;
    }
    .welcome-modal-complete-btn {
        width: 100%;
        padding: 12px;
    }
    .welcome-modal-title {
        font-size: 20px;
    }
    .welcome-modal-plan {
        font-size: 13px;
    }
    .welcome-modal-desc,
    .welcome-modal-email {
        font-size: 11px;
    }
    .welcome-modal-input {
        font-size: 16px;
    }
}

/* Desktop Breadcrumbs Styles */
.desktop-breadcrumbs-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    margin-bottom: 20px;
}

.desktop-breadcrumb {
    margin: 0;
    padding: 0;
    background: transparent;
    display: flex;
    align-items: center;
    gap: 5px;
}

.desktop-breadcrumb .breadcrumb-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
}

.desktop-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
    content: ">";
    color: #555555;
    padding-left: 5px;
    padding-right: 5px !important;
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
}

.desktop-breadcrumb .breadcrumb-item a {
    color: #555555;
    text-decoration: none;
}

.desktop-breadcrumb .breadcrumb-item a:hover {
    color: #0B6CFA;
}

.desktop-breadcrumb .breadcrumb-item.active {
    color: #555555;
}

/* Show/Hide breadcrumbs based on screen size */
.showBreadcrumbs {
    display: block;
}

.hideBreadcrumbs {
    display: none;
}

/* Mobile view - show original breadcrumbs */
@media (max-width: 768px) {
    .showBreadcrumbs {
        display: block;
    }
    
    .hideBreadcrumbs {
        display: none !important;
    }
    
    .hideMonitorBtn {
        display: block;
    }
}

/* Desktop view - show new breadcrumbs */
@media (min-width: 769px) {
    .showBreadcrumbs {
        display: none !important;
    }
    
    .hideBreadcrumbs {
        display: flex !important;
    }
    
    .hideMonitorBtn {
        display: none !important;
    }
}
</style>